export const creditRoutes = [
  {
    path: '/student-credit',
    component: () => import('@/views/studentCredit'),
    name: 'student-credit',
    meta: {
      title: 'Quản lý quỹ xu',
      auth: true
    }
  },
  {
    path: '/student-credit/:id',
    component: () => import('@/views/studentCredit/StudentCreditDetail.vue'),
    name: 'student-credit-detail',
    meta: {
      title: 'chi tiết quỹ xu',
      auth: true
    }
  },
  {
    path: '/student-credit-report',
    component: () => import('@/views/studentCreditReport'),
    name: 'student-credit-report',
    meta: {
      title: 'Báo cáo quỹ xu',
      auth: true
    }
  },
  {
    path: '/add-coin-manager',
    component: () => import('@/views/add-coin-manager/index.vue'),
    name: 'add-coin-manager',
    meta: {
      title: 'Quản lý nạp xu',
      auth: true
    }
  }
]
